import { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Tabs, TabsList, TabsTrigger } from '@components/ui/tabs'
import { cn } from 'lib/utils'

export const AdasTabs = ({
  tabs,
  value,
  onChange,
  className,
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  scrollButtons,
  // eslint-disable-next-line no-unused-vars
  variant,
  ...props
}) => {
  const listRef = useRef()

  useEffect(() => {
    const selected = listRef.current?.querySelector('[data-state="active"]')
    if (selected) selected.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
  }, [value])

  return (
    <Tabs value={value} onValueChange={(val) => onChange && onChange(null, val)} className={cn('w-full', className)} {...props}>
      <TabsList
        ref={listRef}
        className='flex overflow-x-auto gap-1 h-auto p-1 bg-transparent border-b border-divider rounded-none w-full justify-start'
      >
        {tabs.map((tab, index) => (
          <TabsTrigger
            key={`${index}_tab`}
            value={tab.value}
            className={cn(
              'text-sm font-medium whitespace-nowrap uppercase tracking-wide px-4 py-2.5 rounded-none border-b-2 border-transparent text-muted-foreground',
              'data-[state=active]:border-secondary data-[state=active]:text-secondary data-[state=active]:bg-transparent',
              'hover:text-secondary transition-colors'
            )}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  )
}

AdasTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string.isRequired, value: PropTypes.string.isRequired })).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string
}
